import React, { useState, useEffect } from 'react';

const UserForm = ({ onAddUser, editingUser, onSaveUser, onCancelEdit }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  // FIX: PIN temporal
  const [tempPin, setTempPin] = useState('');

  const [access, setAccess] = useState({
    pos: false,
    menu: false,
    supplies: false,
    sales: false,
    costing: false,
    admin: false,
    analysis: false,
    costStructure: false,
    inventory: false,
    dashboard: false,
    comandas: false,
    ticketSettings: false,
    employees: false
  });

  useEffect(() => {
    if (editingUser) {
      setUsername(editingUser.username);
      setPassword('');
      // FIX: Cargar PIN existente al editar (si lo tiene)
      setTempPin(editingUser.pin || '');
      setAccess({
        pos:           editingUser.access?.pos           || false,
        menu:          editingUser.access?.menu          || false,
        supplies:      editingUser.access?.supplies      || false,
        sales:         editingUser.access?.sales         || false,
        costing:       editingUser.access?.costing       || false,
        admin:         editingUser.access?.admin         || false,
        analysis:      editingUser.access?.analysis      || false,
        costStructure: editingUser.access?.costStructure || false,
        inventory:     editingUser.access?.inventory     || false,
        dashboard:     editingUser.access?.dashboard     || false,
        comandas:      editingUser.access?.comandas      || false,
        ticketSettings:editingUser.access?.ticketSettings|| false,
        employees:     editingUser.access?.employees     || false
      });
    } else {
      setUsername('');
      setPassword('');
      setTempPin(''); // FIX: limpiar PIN al resetear
      setAccess({
        pos: false, menu: false, supplies: false, sales: false,
        costing: false, admin: false, analysis: false,
        costStructure: false, inventory: false, dashboard: false,
        comandas: false, ticketSettings: false, employees: false
      });
    }
  }, [editingUser]);

  const handleAccessChange = (e) => {
    const { name, checked } = e.target;
    setAccess({ ...access, [name]: checked });
  };

  // FIX: Solo permitir dígitos y máximo 4 caracteres en PIN
  const handlePinChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 4);
    setTempPin(val);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username) return;
    if (!editingUser && !password) return;

    // FIX: Validar PIN si se proporcionó (debe ser exactamente 4 dígitos o vacío)
    if (tempPin !== '' && tempPin.length !== 4) {
      alert('El PIN temporal debe ser de exactamente 4 dígitos');
      return;
    }

    const userData = {
      ...(editingUser && { id: editingUser.id }),
      username,
      password,
      access,
      // FIX: Incluir PIN temporal (null si vacío)
      pin: tempPin !== '' ? tempPin : null
    };

    onSaveUser(userData);
  };

  const isAdmin = editingUser && editingUser.username === 'admin';

  return (
    <form onSubmit={handleSubmit} className="mb-4">

      {/* ================= USERNAME / PASSWORD ================= */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-[#3F1907] text-sm font-bold mb-1">
            Usuario
          </label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
            required
            disabled={isAdmin}
          />
        </div>

        <div>
          <label className="block text-[#3F1907] text-sm font-bold mb-1">
            Contraseña
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
            required={!editingUser}
          />
        </div>
      </div>

      {/* FIX: ================= PIN TEMPORAL ================= */}
      {!isAdmin && (
        <div className="mb-4">
          <label className="block text-[#3F1907] text-sm font-bold mb-1">
            PIN Temporal (4 dígitos)
          </label>
          <input
            type="text"
            inputMode="numeric"
            value={tempPin}
            onChange={handlePinChange}
            placeholder="Ej: 1234"
            maxLength={4}
            className="w-40 px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907] tracking-widest text-center text-lg"
          />
          <p className="text-xs text-[#58735A] mt-1">
            El usuario usará este PIN hasta que cree su empleado con PIN definitivo.
          </p>
        </div>
      )}

      {/* ================= PERMISOS ================= */}
      <div className="mb-4">
        <label className="block text-[#3F1907] text-sm font-bold mb-2">
          Permisos de Acceso:
        </label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {[
            { name: 'pos',           label: 'Punto de Venta' },
            { name: 'menu',          label: 'Menú' },
            { name: 'supplies',      label: 'Insumos' },
            { name: 'sales',         label: 'Ventas' },
            { name: 'costing',       label: 'Costeo' },
            { name: 'admin',         label: 'Admin' },
            { name: 'analysis',      label: 'Análisis' },
            { name: 'costStructure', label: 'Estructura de Costos' },
            { name: 'inventory',     label: 'Inventario' },
            { name: 'dashboard',     label: 'Dashboard' },
            { name: 'comandas',      label: 'Comandas' },
            { name: 'ticketSettings',label: 'Configuración Ticket' },
            { name: 'employees',     label: 'Empleados' },
          ].map(({ name, label }) => (
            <label key={name} className="flex items-center text-[#3F1907]">
              <input
                type="checkbox"
                name={name}
                checked={access[name]}
                onChange={handleAccessChange}
                className="mr-2"
                disabled={isAdmin}
              />
              {label}
            </label>
          ))}
        </div>
      </div>

      {/* ================= BOTONES ================= */}
      <button
        type="submit"
        className="w-full bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200"
      >
        {editingUser ? 'Actualizar Usuario' : 'Crear Usuario'}
      </button>

      {editingUser && (
        <button
          type="button"
          onClick={onCancelEdit}
          className="w-full bg-gray-500 hover:bg-gray-600 text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200 mt-2"
        >
          Cancelar Edición
        </button>
      )}

    </form>
  );
};

export default UserForm;